var _defs, _path, _path2, _rect, _rect2, _rect3, _polygon, _polygon2, _rect4, _rect5, _polygon3, _polygon4, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    "data-name": "Layer 3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 650 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f5f3f5;}.cls-2{fill:url(#New_Gradient_Swatch_copy_3);}.cls-3{fill:url(#New_Gradient_Swatch_copy_3-2);}.cls-4{fill:url(#New_Gradient_Swatch_copy_3-3);}.cls-5{fill:url(#New_Gradient_Swatch_copy_3-4);}.cls-6{fill:url(#New_Gradient_Swatch_copy_3-5);}.cls-7{fill:url(#New_Gradient_Swatch_copy_3-6);}.cls-8{fill:url(#New_Gradient_Swatch_copy_3-7);}.cls-9{fill:url(#New_Gradient_Swatch_copy_3-8);}.cls-10{fill:url(#New_Gradient_Swatch_copy_3-9);}.cls-11{fill:url(#New_Gradient_Swatch_copy_3-10);}.cls-12{fill:url(#New_Gradient_Swatch_copy_3-11);}.cls-13{fill:url(#New_Gradient_Swatch_copy_3-12);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_3",
    x1: 399.9261,
    y1: 242.5553,
    x2: 453.9906,
    y2: 242.5553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1477,
    stopColor: "#f5f3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2507,
    stopColor: "#f5f3f5",
    stopOpacity: 0.9049
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4677,
    stopColor: "#f5f3f5",
    stopOpacity: 0.6598
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7778,
    stopColor: "#f5f3f5",
    stopOpacity: 0.2712
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9825,
    stopColor: "#f5f3f5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_3-2",
    x1: 402.1019,
    y1: 174.0807,
    x2: 402.1019,
    y2: 187.4743,
    gradientTransform: "matrix(0.0068, 1, -1, 0.0068, 580.1302, -222.5491)",
    xlinkHref: "#New_Gradient_Swatch_copy_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_3-3",
    x1: 401.8255,
    y1: 314.7409,
    x2: 401.8255,
    y2: 297.778,
    gradientTransform: "translate(2.5997 -3.3813) rotate(0.4837)",
    xlinkHref: "#New_Gradient_Swatch_copy_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_3-4",
    x1: 404.1468,
    y1: 245.726,
    x2: 419.9271,
    y2: 228.2002,
    gradientTransform: "translate(288.241 -221.9492) rotate(45)",
    xlinkHref: "#New_Gradient_Swatch_copy_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_3-5",
    x1: 201.6027,
    y1: 322.1973,
    x2: 328.4474,
    y2: 226.613,
    xlinkHref: "#New_Gradient_Swatch_copy_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_3-6",
    x1: 277.4076,
    y1: 168.0368,
    x2: 331.9261,
    y2: 168.0368,
    xlinkHref: "#New_Gradient_Swatch_copy_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_3-7",
    x1: 277.4813,
    y1: 194.4079,
    x2: 338.6663,
    y2: 194.4079,
    xlinkHref: "#New_Gradient_Swatch_copy_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_3-8",
    x1: 277.4813,
    y1: 221.3708,
    x2: 331.9261,
    y2: 221.3708,
    xlinkHref: "#New_Gradient_Swatch_copy_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_3-9",
    x1: 277.4813,
    y1: 249.5182,
    x2: 331.9261,
    y2: 249.5182,
    xlinkHref: "#New_Gradient_Swatch_copy_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_3-10",
    x1: 277.4813,
    y1: 275.8893,
    x2: 331.8519,
    y2: 275.8893,
    xlinkHref: "#New_Gradient_Swatch_copy_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_3-11",
    x1: 358.9456,
    y1: 151.36,
    x2: 358.9456,
    y2: 133.7507,
    gradientTransform: "translate(499.285 -217.2625) rotate(89.6467)",
    xlinkHref: "#New_Gradient_Swatch_copy_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_3-12",
    x1: 379.0012,
    y1: 155.0821,
    x2: 379.0012,
    y2: 137.4728,
    gradientTransform: "translate(764.9055 314.1923) rotate(179.643)",
    xlinkHref: "#New_Gradient_Swatch_copy_3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M399.9261,296.62a54.0645,54.0645,0,0,1,0-108.1289V197.36a45.1954,45.1954,0,0,0,0,90.3907Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M399.9261,296.62v-8.8691a45.1954,45.1954,0,0,0,0-90.3907v-8.8691a54.0645,54.0645,0,1,1,0,108.1289Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 398.3011,
    y: 165.9542,
    width: 7.667,
    height: 8.8692,
    transform: "translate(230.3299 571.9206) rotate(-89.7981)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 395.4352,
    y: 176.3428,
    width: 13.3333,
    height: 8.8693,
    transform: "translate(218.5836 581.6359) rotate(-89.6089)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 397.3908,
    y: 297.8148,
    width: 8.8695,
    height: 16.8893,
    transform: "translate(-2.5711 3.4031) rotate(-0.4837)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "406.387 323.882 252.828 323.882 252.828 120.337 261.699 120.337 261.699 315.012 397.459 315.012 397.458 314.735 406.327 314.678 406.387 323.882"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "400.09 172.581 359.628 129.213 258.667 129.213 258.667 120.343 363.484 120.343 406.576 166.53 400.09 172.581"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 360.8987,
    y: 159.2876,
    width: 8.8693,
    height: 21.7777,
    transform: "translate(192.9647 534.4806) rotate(-89.6557)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 400.4615,
    y: 232.5284,
    width: 23.1508,
    height: 8.8692,
    transform: "translate(-46.8754 360.759) rotate(-45)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "393.026 262.246 376.223 245.717 382.444 239.393 392.975 249.754 400.716 242.012 406.988 248.284 393.026 262.246"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "392.715 350.842 223.188 350.842 223.497 133.04 258.192 133.381 258.105 142.25 232.355 141.997 232.071 341.973 383.729 341.973 383.492 323.631 392.361 323.515 392.715 350.842"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 277.4076,
    y: 163.6022,
    width: 54.5186,
    height: 8.8691
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 277.4813,
    y: 189.9733,
    width: 61.1851,
    height: 8.8691
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 277.4813,
    y: 216.9362,
    width: 54.4448,
    height: 8.8691
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 277.4813,
    y: 245.0837,
    width: 54.4448,
    height: 8.8691
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 277.4813,
    y: 271.4548,
    width: 54.3706,
    height: 8.8691
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 350.1681,
    y: 138.1207,
    width: 17.555,
    height: 8.8693,
    transform: "translate(214.1798 500.6152) rotate(-89.6467)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 347.3244,
    y: 158.4078,
    width: 23.0198,
    height: 8.8692,
    transform: "translate(194.2553 520.8836) rotate(-89.7224)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 380.5657,
    y: 161.5015,
    width: 8.8693,
    height: 17.555,
    transform: "translate(212.3259 554.2109) rotate(-89.643)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/Document.c78864822128668f17f66218337e15ba.svg";
export { ForwardRef as ReactComponent };